import React from "react"
import { HubSpotForm } from "@shared"

const ContactForm = props => <HubSpotForm {...props} />

export default ContactForm
